import type { FC } from 'react';

const ExploreBackground: FC = () => (
  <>
    <div
      className="position-absolute bg-darker"
      style={{
        // CON-SPECIFIC: con banner
        height: '100%',
        width: '100%',
        // backgroundImage: "url('https://cdn.furality.org/files/web/bg/ultra-background-1-dark.webp')",
        backgroundPosition: 'top center',
        backgroundSize: '200px',
        backgroundRepeat: 'repeat',
        zIndex: '-2',
      }}
    />
    {/* <div
      className="position-absolute"
      style={{
        // CON-SPECIFIC: con banner
        backgroundImage: "url('https://media.cdn.furality.online/image/f8/bg/stars.png')",
        height: '100%',
        width: '100%',
        backgroundPosition: 'top center',
        backgroundRepeat: 'repeat',
        backgroundSize: '1200px 1200px',
        zIndex: '-1',
      }}
    /> */}
  </>
);

export default ExploreBackground;
